// extracted by mini-css-extract-plugin
module.exports = {"menuItemList":"MenuItemList__menuItemList___2lyVn"};